import { ResetPasswordState } from './useResetPasswordStore.types';

/**
 * Represents the initial state for the ResetPasswordStore.
 */
export const initialState: ResetPasswordState = {
  usersTimeToNextTry: {},
};
